// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jquuhiyfkknzmflwyexb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpxdXVoaXlma2tuem1mbHd5ZXhiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3MTMyMDQsImV4cCI6MjA2NjI4OTIwNH0.ms-RGO6l-2S2fKT7HOykufjnfTh8TVLRRPK3kxGRVx0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);